var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Pricing, Tag } from "@cloudy/ui";
import { useMutation, useQuery } from "@tanstack/react-query";
import { XIcon } from "lucide-react";
import posthog from "posthog-js";
import { apiClient } from "src/api/client";
import { Button } from "src/components/Button";
import { Dialog, DialogContent } from "src/components/Dialog";
import LoadingSpinner from "src/components/LoadingSpinner";
import { useWorkspaceSlug } from "src/stores/workspace";
import { useCustomerStatus } from "src/utils/useCustomerStatus";
import { useSubscriptionModalStore } from "./subscriptionModalStore";
var useProducts = function () {
    return useQuery({
        queryKey: ["payments", "products"],
        queryFn: function () { return apiClient.get("/api/payments/products").then(function (res) { return res.data; }); },
    });
};
var useCheckout = function () {
    var wsSlug = useWorkspaceSlug();
    return useMutation({
        mutationFn: function (priceId) { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient
                            .get("/api/payments/checkout", {
                            params: {
                                wsSlug: wsSlug,
                                priceId: priceId,
                                successUrl: window.location.origin + window.location.pathname,
                                cancelUrl: window.location.origin + window.location.pathname,
                            },
                        })
                            .then(function (res) { return res.data; })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.url];
                }
            });
        }); },
    });
};
var usePaymentGuard = function () {
    var _a = useCustomerStatus(), customerStatus = _a.data, isLoading = _a.isLoading, isFetched = _a.isFetched;
    var setIsOpen = useSubscriptionModalStore().setIsOpen;
    // useEffect(() => {
    // 	if (!isLoading && isFetched) {
    // 		if (customerStatus?.customerStatus && !customerStatus.customerStatus.isActive) {
    // 			posthog.capture("force_show_subscription_modal");
    // 			setIsOpen(true, false);
    // 		}
    // 	}
    // }, [isLoading, isFetched, customerStatus]);
};
export var SubscriptionModal = function () {
    var _a = useCustomerStatus(), customerStatus = _a.data, isCustomerStatusLoading = _a.isLoading, isCustomerStatusFetched = _a.isFetched;
    var _b = useProducts(), data = _b.data, isProductsLoading = _b.isLoading;
    var _c = useCheckout(), checkout = _c.mutate, isCheckoutLoading = _c.isPending;
    usePaymentGuard();
    var _d = useSubscriptionModalStore(), isOpen = _d.isOpen, allowClose = _d.allowClose, setIsOpen = _d.setIsOpen;
    var missingCustomerStatus = !isCustomerStatusLoading && !(customerStatus === null || customerStatus === void 0 ? void 0 : customerStatus.customerStatus);
    var isLoading = isProductsLoading || isCustomerStatusLoading || !isCustomerStatusFetched;
    var products = data === null || data === void 0 ? void 0 : data.products;
    var handleSubscribe = function (priceId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            posthog.capture("subscribe");
            checkout(priceId, {
                onSuccess: function (url) {
                    window.location.href = url;
                },
            });
            return [2 /*return*/];
        });
    }); };
    var handleClose = function (force) {
        if (allowClose || force) {
            posthog.capture("hide_subscription_modal");
            setIsOpen(false, false);
        }
    };
    return (_jsx(Dialog, { open: isOpen, onOpenChange: function (open) {
            if (!open) {
                handleClose();
            }
        }, children: _jsxs(DialogContent, { children: [allowClose && (_jsx("div", { className: "-mr-2 -mt-2 flex justify-end", children: _jsx(Button, { onClick: function () { return handleClose(); }, size: "icon-xs-overflow", variant: "ghost", children: _jsx(XIcon, { className: "h-4 w-4" }) }) })), isLoading ? (_jsx("div", { children: _jsx(LoadingSpinner, {}) })) : missingCustomerStatus ? (_jsxs("div", { children: [_jsx("h3", { className: "text-center text-lg font-medium", children: "Something went wrong" }), _jsxs("p", { className: "text-center text-sm text-secondary", children: ["Woah this isn't supposed to happen. Please contact us at", " ", _jsx("a", { href: "mailto:founders@usecloudy.com", className: "text-accent", children: "founders@usecloudy.com" }), "."] }), _jsxs("p", { className: "text-center text-sm text-secondary", children: ["For a faster response, shoot Jenn a dm on X:", " ", _jsx("a", { href: "https://x.com/jennmueng", className: "text-accent", children: "@jennmueng" })] })] })) : (_jsx("div", { children: products === null || products === void 0 ? void 0 : products.map(function (product) { return (_jsxs("div", { className: "flex flex-col items-center gap-4", children: [_jsxs("div", { className: "flex flex-col items-center gap-2", children: [_jsx("img", { src: "/logo.png", className: "w-8", alt: "Cloudy Logo" }), _jsxs("div", { className: "flex flex-row items-center gap-2", children: [_jsx("h3", { className: "text-lg font-medium", children: product.name }), "tag" in product.metadata ? _jsx(Tag, { children: product.metadata.tag }) : null] }), _jsx("div", { className: "-mb-2 text-center text-sm text-secondary", children: "Monthly" }), _jsx(Pricing, { price: product.defaultPrice, fullPrice: product.fullPrice, showDiscount: false }), _jsx("div", { className: "text-center text-sm text-secondary", children: product.description })] }), _jsx(Button, { className: "self-stretch", onClick: function () { return handleSubscribe(product.defaultPrice.id); }, disabled: isCheckoutLoading, children: isCheckoutLoading ? _jsx(LoadingSpinner, { size: "xs", variant: "background" }) : "Subscribe now" }), _jsxs("div", { className: "flex w-full flex-col items-start rounded-md bg-card p-4", children: [_jsx("div", { className: "text-sm font-medium text-secondary", children: "Features include:" }), _jsx("ul", { className: "list-outside list-disc px-4", children: product.marketingFeatures.map(function (feature) { return (_jsx("li", { className: "my-1 text-xs text-secondary", children: feature.title }, feature.title)); }) })] }), _jsxs("div", { className: "text-center text-xs text-secondary", children: ["Something wrong? Contact us at", " ", _jsx("a", { href: "mailto:founders@usecloudy.com", className: "text-accent", children: "founders@usecloudy.com" })] }), _jsx("a", { className: "cursor-pointer text-center text-xs font-medium text-accent hover:underline active:text-accent/80", href: "/signout", children: "Sign out" })] }, product.id)); }) }))] }) }));
};
